<template>
  <base-chart
    title="Transaction Volume"
    :options="chartOptions"
    :height="height"
    @chart-click="handleDrillDown"
  />
</template>

<script>
import BaseChart from './BaseChart.vue'
import ApiMixin from '@/mixins/api'

export default {
  name: 'TransactionChart',
  components: {
    BaseChart
  },
  mixins: [ApiMixin],
  props: {
    height: {
      type: String,
      default: '400px'
    },
    dateRange: {
      type: Object,
      default: () => ({
        start: null,
        end: null
      })
    }
  },
  data () {
    return {
      loading: false,
      transactions: []
    }
  },
  computed: {
    chartOptions () {
      return {
        title: {
          show: false
        },
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            const param = params[0]
            return `${param.name}<br/>Amount: $${param.value.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}`
          }
        },
        xAxis: {
          type: 'category',
          data: this.dates,
          boundaryGap: false,
          axisLabel: {
            rotate: 45,
            formatter: (value) => {
              const date = new Date(value)
              return `${date.getMonth() + 1}/${date.getDate()}`
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: (value) => {
              return '$' + value.toLocaleString('en-US')
            }
          }
        },
        series: [
          {
            name: 'Transaction Amount',
            type: 'line',
            smooth: true,
            data: this.amounts,
            areaStyle: {
              opacity: 0.3
            },
            emphasis: {
              focus: 'series'
            }
          }
        ]
      }
    },
    dates () {
      if (this.transactions.length > 0) {
        return this.transactions.map(t => t.date)
      }
      return this.generateSampleDates()
    },
    amounts () {
      if (this.transactions.length > 0) {
        return this.transactions.map(t => t.amount)
      }
      return this.generateSampleData()
    }
  },
  mounted () {
    this.fetchTransactionData()
  },
  watch: {
    dateRange: {
      deep: true,
      handler () {
        this.fetchTransactionData()
      }
    }
  },
  methods: {
    async fetchTransactionData () {
      this.loading = true
      try {
        const params = {}
        if (this.dateRange.start) {
          params.start_date = this.dateRange.start
        }
        if (this.dateRange.end) {
          params.end_date = this.dateRange.end
        }

        const response = await this.api({
          url: '/analytics/transactions',
          method: 'get',
          params
        })

        if (response.data && response.data.transactions) {
          this.transactions = response.data.transactions
        }
      } catch (err) {
        console.error('Error fetching transaction data:', err)
      } finally {
        this.loading = false
      }
    },
    handleDrillDown (params) {
      const date = params.name
      this.$emit('drill-down', { date, amount: params.value })
      this.$router.push({
        name: 'Transactions',
        query: { date }
      })
    },
    generateSampleDates () {
      const dates = []
      const today = new Date()
      for (let i = 29; i >= 0; i--) {
        const date = new Date(today)
        date.setDate(date.getDate() - i)
        dates.push(date.toISOString().split('T')[0])
      }
      return dates
    },
    generateSampleData () {
      const data = []
      for (let i = 0; i < 30; i++) {
        const baseAmount = 15000
        const variance = Math.random() * 10000 - 5000
        const weekendFactor = (i % 7 === 0 || i % 7 === 6) ? 0.7 : 1
        data.push(Math.round((baseAmount + variance) * weekendFactor))
      }
      return data
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/TransactionChart.vue